document.addEventListener("DOMContentLoaded", function () {
  const couponElement = document.querySelector("[data-auto-apply-coupon]");

  if (couponElement) {
    const couponCode = couponElement.dataset.autoApplyCoupon;

    if (couponCode) {
      fetch("/discount/" + couponCode, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            console.log("Coupon applied successfully:", couponCode);
            // Optional: reload to reflect discount in cart
            // window.location.reload();
          } else {
            console.error("Failed to apply coupon:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error applying coupon:", error);
        });
    }
  }
});